import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import '../assets/style/bubble.scss';

const Bubble = ({
  size, distance, position, time, delay,
}) => {
  const [isActive, setIsActive] = useState(false);
  const bubbleRef = useRef(null);

  useEffect(() => {
    // Initialize IntersectionObserver
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // Start animation when section is in view
        setIsActive(true);
      } else {
        // Stop animation when section goes out of view
        setIsActive(false);
        cancelAnimationFrame(bubbleRef.current);
      }
    }, { threshold: 0 });

    // Observe the section
    observer.observe(bubbleRef.current);

    // Initialize PIXI once when the component mounts
    // const bubbleRefCurrent = bubbleRef.current;
    // Cleanup IntersectionObserver, PIXI, and event listener when the component unmounts
    return () => {
      observer.disconnect();
      // bubbleRefCurrent.destroy();
    };
  }, []);

  const customStyles = {
    '--size': size,
    '--distance': distance,
    '--position': position,
    '--time': time,
    '--delay': delay,
  };

  return <div ref={bubbleRef} className={`bubble${isActive ? ' foam' : ''}`} style={customStyles} />;
};

Bubble.propTypes = {
  size: PropTypes.string.isRequired,
  distance: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  delay: PropTypes.string.isRequired,
};

export default Bubble;
